import type { ReactElement } from 'react';
import Banner from 'components/shared/Banner';

function PlanUpdatedBanner(): ReactElement {
  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <div style={{ width: '225px' }}>
        <Banner.Success isCentered>
          <div className="u-text--center">
            Plan updates saved!
          </div>
        </Banner.Success>
      </div>
    </div>
  );
}

export default PlanUpdatedBanner;
